//CREATE_SERVICE_REQUEST
export const CREATE_SERVICE_REQUEST_REQUEST =
  "CREATE_SERVICE_REQUEST_REQUEST";
export const CREATE_SERVICE_REQUEST_SUCCESS =
  "CREATE_SERVICE_REQUEST_SUCCESS";
export const CREATE_SERVICE_REQUEST_FAIL =
  "CREATE_SERVICE_REQUEST_FAIL";

//DELETE_SERVICE_REQUEST
export const DELETE_SERVICE_REQUEST_REQUEST =
"DELETE_SERVICE_REQUEST_REQUEST";
export const DELETE_SERVICE_REQUEST_SUCCESS =
"DELETE_SERVICE_REQUEST_SUCCESS";
export const DELETE_SERVICE_REQUEST_FAIL =
"DELETE_SERVICE_REQUEST_FAIL";


//APPROVE_SERVICE_REQUEST
export const APPROVE_SERVICE_REQUEST_REQUEST =
"APPROVE_SERVICE_REQUEST_REQUEST";
export const APPROVE_SERVICE_REQUEST_SUCCESS =
"APPROVE_SERVICE_REQUEST_SUCCESS";
export const APPROVE_SERVICE_REQUEST_FAIL =
"APPROVE_SERVICE_REQUEST_FAIL";

//REJECT_SERVICE_REQUEST
export const REJECT_SERVICE_REQUEST_REQUEST =
"REJECT_SERVICE_REQUEST_REQUEST";
export const REJECT_SERVICE_REQUEST_SUCCESS =
"REJECT_SERVICE_REQUEST_SUCCESS";
export const REJECT_SERVICE_REQUEST_FAIL =
"REJECT_SERVICE_REQUEST_FAIL";

//GET_SERVICE_REQUEST
export const GET_SERVICE_REQUEST_REQUEST =
"GET_SERVICE_REQUEST_REQUEST";
export const GET_SERVICE_REQUEST_SUCCESS =
"GET_SERVICE_REQUEST_SUCCESS";
export const GET_SERVICE_REQUEST_FAIL =
"GET_SERVICE_REQUEST_FAIL";

//ARCHIVE_SERVICE_REQUEST
export const ARCHIVE_SERVICE_REQUEST_REQUEST =
"ARCHIVE_SERVICE_REQUEST_REQUEST";
export const ARCHIVE_SERVICE_REQUEST_SUCCESS =
"ARCHIVE_SERVICE_REQUEST_SUCCESS";
export const ARCHIVE_SERVICE_REQUEST_FAIL =
"ARCHIVE_SERVICE_REQUEST_FAIL";
